var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex items-center justify-center"},[_c('div',{staticClass:"warpper"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.content.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }